/*
import {
  _hm,
  _ht,
  f,
  gs,
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _ht from './_ht';
import * as _hm from './_hf';

import * as ihd from './ihd';
import * as ihdI10 from './ihdI10';

export const itlI10z = () => ({
  i10rz: {},
  i101s: [],
  i102s: [],
}) as _ht.dz;

export const crtI10zAsync = async () => {
  const _gUserz = gs.useUserz();
  const _i10z = itlI10z();
  _hm.udtDz(_i10z.i10rz, {
    ... ihd.i('i10r'),
    i10r_31r1f: _gUserz.crt._31rz._fst,
  });
  _i10z.i101s = [];
  _i10z.i102s = [];
  return _i10z;
};

export const loadI10rLsAsync = async (pz: {
  _31r_fst: _ht.n,
  i1zr_fst?: _ht.n,
  i10r_fst?: _ht.n,
  i10rt1100i?: _ht.n,
  i10r_fsts?: _ht.ls,
  i18r_fst?: _ht.n,
  i102i10r1f?: _ht.n,
  lwrType?: 1,
}) => {
  _hm.logOst('icvI10___Mz.loadI10rLsAsync -> ihd.grtPzLoadI10rPs');
  let _cdn = cmFTH.vdd();
  if (pz._31r_fst && pz._31r_fst > 0) _cdn += ` AND i10r_31r1f=${pz._31r_fst}`;
  if (pz?.i1zr_fst) {
    _cdn += ` AND _fst IN (
      SELECT 
        i1z1i10r1f 
      FROM 
        i1z1s 
      WHERE 
        COALESCE(_dlt,-1)<>1 AND 
        i1z1i1zr1k IN ( 
          SELECT 
            _key 
          FROM 
            i1zrs 
          WHERE 
            COALESCE(_dlt,-1) <> 1 AND _vsn = _ltt AND 
            _fst = ${pz?.i1zr_fst}
        )
    )`;
  }
  if (_hm.f(pz?.i10r_fst)) 
    _cdn += ` AND _fst <> ${pz?.i10r_fst}`;
  if (_hm.f(pz?.i10rt1100i)) 
    _cdn += ` AND i10rt1100i = ${pz?.i10rt1100i}`;
  if (_hm.f(pz?.i10r_fsts)) 
    _cdn += ` AND _fst IN (${_hm.join(pz?.i10r_fsts)})`;
  if (_hm.f(pz?.i18r_fst)) {
    _cdn += ` AND _fst NOT IN (
      SELECT
        i151i10r1f
      FROM
        i151s
      WHERE
        ${cmFTH.vdd(false)}
        AND i151i15r1k = (
          SELECT
            _key
          FROM
            i15rs
          WHERE
            ${cmFTH.vdd()}
            AND _fst = (
              SELECT
                i18ri15r1f
              FROM
                i18rs
              WHERE
                ${cmFTH.vdd()}
                AND _fst = ${pz?.i18r_fst}
            )
        )
    )`;
  }
  if (_hm.f(pz?.i102i10r1f)) {
    _cdn += ` AND _key IN (
      SELECT
        i102i10r1k
      FROM
        i102s
      WHERE
        ${cmFTH.vdd()}
        AND i102i10r1f = ${pz?.i102i10r1f}
    )`;
  }
  return await cmFTH.loadLsAsync({
    tgt: 'i10rs',
    cdn: _cdn,
    lwrz: 
      pz.lwrType == 1 ?
      {
        i11rs: {
          tgt: 'i11rs',
          cdn: cmFTH.vdd() + ` AND _fst = {i11r_fst}`,
          rlcz: {
            'i11r_fst': 'i10rs.i10ri11r1f',
          },
          lwrz: {
            i111s: {
              tgt: 'i111s',
              fld: '_fst as key, _pfx as pfx, *',
              cdn: cmFTH.vdd() + ` AND i111i11r1k = {i11r_key}`,
              rlcz: {
                'i11r_key': 'i11rs._key'
              },
              tailz: {
                odr: '_icn',
              },
              lwrz: {
                i101s: {
                  tgt: 'i101s',
                  cdn: cmFTH.vdd() + ` AND i101i10r1k = {i10r_key} AND i101i1111f = {i111_fst}`,
                  rlcz: {
                    i10r_key: 'i10rs._key',
                    i111_fst: 'i111s._fst',
                  }
                },
              }
            }
          }
        },
      }
      : undefined,
  })
};

export const loadI10rDzAsync = async (pz: {
  i10r_fst: _ht.n,
  vsn?: _ht.n,
}) => {
  const _gUserz = gs.useUserz();
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : cmFTH.vdd();
  _cdn += ` AND _fst = ${pz.i10r_fst}`;
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i10rs',
    cdn: _cdn,
    lwrz: {
      i101s: {
        tgt: 'i101s',
        cdn: cmFTH.vdd(false) + ` AND i101i10r1k={i10r_key}`,
        rlcz: {
          i10r_key: 'i10rs._key',
        },
      },
      i102s: { // 子部屋
        tgt: 'i102s',
        cdn: cmFTH.vdd(false) + ` AND i102i10r1k={i10r_key}`,
        rlcz: {
          i10r_key: 'i10rs._key',
        },
        tailz: {
          odr: 'i102i10r1f',
        },
        lwrz: {
          i10rs: {
            tgt: 'i10rs',
            cdn: cmFTH.vdd(false) + ` AND _fst = {i102i10r1f}`,
            rlcz: {
              i102i10r1f : 'i102s.i102i10r1f'
            }
          }
        },
      },
    }
  });
  return {
    i10rz: { ... _dz, cldz: undefined },
    i101s: _dz.cldz?.i101s ?? [],
    i102s: _dz.cldz?.i102s ?? [],
  };
};

export const loadI10rRzAsync = async (
) => {
  const _gUserz = gs.useUserz();
  const _ls = await cmFTH.loadLsAsync({
    tgt: 'i10rs',
    cdn: cmFTH.vdd() + ` AND i10r_31r1f=${_gUserz.crt._31rz._fst}`,
  });
  return _hm.cvtLsToDz(_ls, ( _dz: _ht.dz ) => String(_dz._fst))
};

export const saveI10rDzAsync = async (pz: {
  i10z: _ht.dz,
//  sPz?: _ht.dz,
}) => {
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i10rs',
    dz: {
      ... pz.i10z.i10rz,
    },
    lwrz: {
      i101s: {
        tgt: 'i101s',
        ls: pz.i10z.i101s,
        udtz: {
          i101_31r1f: 'i10rs.i10r_31r1f',
          i101i10r1k: 'i10rs._key',
        }
      },
      i102s: {
        tgt: 'i102s',
        ls: pz.i10z.i102s,
        udtz: {
          i102_31r1f: 'i10rs.i10r_31r1f',
          i102i10r1k: 'i10rs._key',
        }
      },
    }
  });
  return {
    i10rz: { ... _dz, cldz: undefined },
    i101s: _dz.cldz?.i101s,
    i102s: _dz.cldz?.i102s,
  }
};

/*
export const loadI102LsAsync = async (pz: {
  _31r_fst: _ht.n,
  lwrz: {
    i10rs: _ht.b,
  }
}) => {
  let _cdn = cmFTH.vdd();
  if (pz._31r_fst && pz._31r_fst > 0) _cdn += ` AND i102_31r1f=${pz._31r_fst}`;
  return await cmFTH.loadLsAsync({
    tgt: 'i102s',
    cdn: _cdn,
    lwrz: 
      pz.lwrType == 1 ?
      {
        i11rs: {
          tgt: 'i11rs',
          cdn: cmFTH.vdd() + ` AND _fst = {i11r_fst}`,
          rlcz: {
            'i11r_fst': 'i10rs.i10ri11r1f',
          },
          lwrz: {
            i111s: {
              tgt: 'i111s',
              fld: '_fst as key, _pfx as pfx, *',
              cdn: cmFTH.vdd() + ` AND i111i11r1k = {i11r_key}`,
              rlcz: {
                'i11r_key': 'i11rs._key'
              },
              tailz: {
                odr: '_icn',
              },
              lwrz: {
                i101s: {
                } 
              }
            }
          }
        },
      }
      : undefined,
  })
};
*/